import { render, staticRenderFns } from "./EditMetadataDialog.vue?vue&type=template&id=11409fbb"
import script from "./EditMetadataDialog.vue?vue&type=script&lang=js"
export * from "./EditMetadataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports